export default __webpack_public_path__ + "static/media/eye.52c9da33.svg";